import {
  Field,
  Grid,
  Label,
  Title,
  Value,
  Container,
  Input,
  CardChargeBack,
  ChargeBackTitle,
  ButtonConfirm,
} from "./style";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Api from "../../../../adapters/api/api";
import moment from "moment";
import { useToast } from "../../../../hooks/Toast";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

interface IContraCanceledInfo {
  id: string;
  contract_id: string;
  cancelled_at: string;
  show_address: string;
  show_time: string;
  show_date: string;
  payment_type: string;
  show_tax: string;
  show_total_price: string;
  show_price: string;
  cancelation_description: string;
  service_provider_name: string;
  service_provider_faturaagil_id: string;
  contract_pagarme_id: string;
  service_provider_apresentation_name: string;
  user_name: string;
  service_plan: string;
  service_type: string;
  service_provider_email: string;
  service_provider_phone: string;
  user_phone: string;
  user_email: string;
}

export const ContractCanceledInfo: React.FC = () => {
  const { contract_id } = useParams();
  const { addToast } = useToast();
  const navigate = useNavigate();

  const [contracCancelledInfo, setContracCancelledInfo] =
    useState<IContraCanceledInfo | null>(null);
  const [musicianValue, setMusicianValue] = useState("");
  const [showMusicValue, setShowMusicValue] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (contract_id) {
      getContractCancelledInfo(contract_id);
    }
  }, [contract_id]);

  const getContractCancelledInfo = async (contract_id: string) => {
    try {
      const contractInfo = await Api.get(
        `/admin/contract/cancelled/info?id=${contract_id}`
      );
      setContracCancelledInfo(contractInfo.data);
      console.log(contractInfo.data);
    } catch (err) {
      console.log(err);
    }
  };

  const toggle = () => setModalOpen(!modalOpen);

  const confirmRefundModal = () => {
    return (
      <>
        <Modal isOpen={modalOpen} toggle={toggle}>
          <ModalHeader toggle={toggle}>Confirmar Estorno</ModalHeader>
          <ModalBody>
            Deseja confirmar o estorno dos valores?
            <br />
            <strong>Contrato ID:</strong> R$ {contract_id} <br />
            <strong>Valor para o músico:</strong> R$ {musicianValue} <br />
            <strong>Valor para o Show Music:</strong> R$ {showMusicValue} <br />
            <br />
            ⚠️ Após o estorno, a operação não poderá ser revertida.
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Cancelar
            </Button>
            <Button color="danger" onClick={postChargeBack}>
              Confirmar
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  };

  const postChargeBack = async () => {
    try {
      if (!musicianValue && !showMusicValue) {
        addToast({
          title: "Valores errados",
          description: "Não é possivel estornar sem valor.",
          type: "error",
        });
        return;
      }
      await Api.post(`/admin/contract/cancelled/chargeback`, {
        contract_id: contract_id,
        service_provider_value: musicianValue,
        show_music_value: showMusicValue,
      });
      addToast({
        title: "Estorno realizado",
        description: "Estorno realizado",
        type: "success",
      });
      navigate(`/contractCanceled`);
    } catch (err) {
      addToast({
        title: "Erro",
        description: "Erro ao realizar o estorno",
        type: "error",
      });
      console.log(err);
    } finally {
      toggle();
    }
  };

  const handleCurrency = (value: string) => {
    let val = value.replace(/[^0-9,]/g, "");

    const parts = val.split(",");

    if (parts.length > 2) {
      val = parts[0] + "," + parts[1];
    }

    if (parts[1]) {
      parts[1] = parts[1].substring(0, 2);
      val = parts[0] + "," + parts[1];
    }

    return val;
  };

  const renderForm = () => {
    if (!contracCancelledInfo) {
      return null;
    }
    return (
      <>
        <Container>
          <Title>📄 Contrato Cancelado</Title>
          <Title>Show</Title>
          <Grid>
            <Field>
              <Label>ID Contrato</Label>
              <Value>{contracCancelledInfo.contract_id}</Value>
            </Field>

            <Field>
              <Label>Plano</Label>
              <Value>{contracCancelledInfo.service_plan}</Value>
            </Field>

            <Field>
              <Label>Tipo</Label>
              <Value>{contracCancelledInfo.service_type}</Value>
            </Field>

            <Field>
              <Label>Data Show</Label>
              <Value>{`${contracCancelledInfo.show_date} ${contracCancelledInfo.show_time}`}</Value>
            </Field>

            <Field>
              <Label>Preço Total</Label>
              <Value>{contracCancelledInfo.show_total_price}</Value>
            </Field>

            <Field>
              <Label>Cancelado em</Label>
              <Value>{contracCancelledInfo.cancelled_at}</Value>
            </Field>

            <Field>
              <Label>Tipo Pagamento</Label>
              <Value>{contracCancelledInfo.payment_type} </Value>
            </Field>

            <Field>
              <Label>Taxa do Show</Label>
              <Value>{contracCancelledInfo.show_tax} </Value>
            </Field>

            <Field>
              <Label>Valor Total Show Music</Label>
              <Value>{contracCancelledInfo.show_total_price} </Value>
            </Field>

            <Field>
              <Label>Valor do Show</Label>
              <Value>{contracCancelledInfo.show_price} </Value>
            </Field>

            <Field>
              <Label>Pagarme ID</Label>
              <Value>{contracCancelledInfo.contract_pagarme_id} </Value>
            </Field>
          </Grid>

          <Title>Contratante</Title>
          <Grid>
            <Field>
              <Label>Usuário</Label>
              <Value>{contracCancelledInfo.user_name}</Value>
            </Field>

            <Field>
              <Label>Email Usuário</Label>
              <Value>{contracCancelledInfo.user_email}</Value>
            </Field>

            <Field>
              <Label>Telefone Usuário</Label>
              <Value>{contracCancelledInfo.user_phone}</Value>
            </Field>
          </Grid>
          <Title>Músico</Title>
          <Grid>
            <Field>
              <Label>Músico</Label>
              <Value>{contracCancelledInfo.service_provider_name}</Value>
            </Field>

            <Field>
              <Label>Email Músico</Label>
              <Value>{contracCancelledInfo.service_provider_email}</Value>
            </Field>

            <Field>
              <Label>Telefone Músico</Label>
              <Value>{contracCancelledInfo.service_provider_phone}</Value>
            </Field>
          </Grid>
          <CardChargeBack>
            <ChargeBackTitle>Estorno de Valores</ChargeBackTitle>
            <Grid>
              <Field>
                <Label>Valor estornado para o músico</Label>

                <Input
                  value={musicianValue}
                  onChange={(e) => {
                    setMusicianValue(handleCurrency(e.target.value));
                  }}
                  placeholder="0,00"
                />
              </Field>

              <Field>
                <Label>Valor estornado para Show Music</Label>
                <Input
                  value={showMusicValue}
                  onChange={(e) => {
                    setShowMusicValue(handleCurrency(e.target.value));
                  }}
                  placeholder="0,00"
                />
              </Field>
            </Grid>

            <ButtonConfirm onClick={toggle}>Confirmar Estorno</ButtonConfirm>
          </CardChargeBack>
        </Container>
        {confirmRefundModal()}
      </>
    );
  };

  return <>{renderForm()}</>;
};
